<script>
  import { getContext, onDestroy } from "svelte"
  import { useOrderTableStylesQuery } from "./useOrderTableStylesQuery.js";
  import { useOrderTableStyleDetailsQuery } from "./useOrderTableStyleDetailsQuery.js";
  import EnsureFetchedQueries from "../../../components/functional/EnsureFetchedQueries.svelte";

  // props
  /**
   * @type {string}
   */
  export let projectId

  /**
   * This prop will determine at what interval the data will be refetched.
   * Set this to "false" to disable refetching, or provide refetching interval in milliseconds.
   * @type {false|number}
   */
  export let refetchInterval = false

  export let OrderTableStore

  const {
    StyleIndex,
    Styles,
  } = OrderTableStore

  // error handlers
  const {handleFetchErrors} = getContext("fetchErrorHandler")

  // svelte-query
  const stylesQueryResult = useOrderTableStylesQuery(projectId, handleFetchErrors, refetchInterval)
  const cleanup = stylesQueryResult.subscribe(val => {
    if (val.data) Styles.set(val.data)
  })
  $: styleDetailsQueryResult = useOrderTableStyleDetailsQuery(projectId, $StyleIndex, handleFetchErrors, refetchInterval)

  onDestroy(() => cleanup())
</script>

<EnsureFetchedQueries
  queries={[
    $stylesQueryResult,
    $styleDetailsQueryResult,
  ]}
>
  <slot
    projectId={projectId}
    styles={$stylesQueryResult.data}
    ordersData={$styleDetailsQueryResult.data}
  />
</EnsureFetchedQueries>
